










































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import { State as topoState} from '@/store/modules/topology';
import Topo from './topo.vue';
import TopoChart from './topo-chart.vue';
import DependencySankey from './dependency-sankey.vue';
import ChartLine from './chart-line.vue';

@Component({
  components: {
    Topo, ChartLine, TopoChart, DependencySankey,
  },
})
export default class TopoInstanceDependency extends Vue {
  @Getter('durationTime') private durationTime: any;
  @State('rocketTopo') private stateTopo!: topoState;
  @State('rocketDashboard') private rocketDashboard: any;
  @Getter('intervalTime') private intervalTime: any;
  @Mutation('rocketTopo/SET_INSTANCE_DEPEDENCE_TYPE') private SET_MODE_STATUS: any;
  @Action('rocketTopo/GET_INSTANCE_DEPENDENCY_METRICS') private GET_INSTANCE_DEPENDENCY_METRICS: any;

  private showInfo: boolean = true;

  private setMode(mode: string) {
    this.GET_INSTANCE_DEPENDENCY_METRICS({
      ...this.stateTopo.selectedInstanceCall,
      durationTime: this.durationTime,
      mode,
    });
  }
}

